
export const IGUAL = "igual";
export const QUITADO = "quitado";
export const AGREGADO = "agregado";

const partir = (texto) => (texto || "").split(/(\s+)/).filter((parte) => parte.length > 0);

const agregar = (resultado, tipo, texto) => {
  const ultimo = resultado[resultado.length - 1];
  if (ultimo && ultimo.tipo === tipo) {
    ultimo.texto += texto;
  } else {
    resultado.push({ tipo, texto });
  }
};

export const calcularDiferencias = (original, corregido) => {
  const a = partir(original);
  const b = partir(corregido);

  let inicio = 0;
  while (inicio < a.length && inicio < b.length && a[inicio] === b[inicio]) inicio++;

  let finA = a.length;
  let finB = b.length;
  while (finA > inicio && finB > inicio && a[finA - 1] === b[finB - 1]) {
    finA--;
    finB--;
  }

  const medioA = a.slice(inicio, finA);
  const medioB = b.slice(inicio, finB);
  const filas = medioA.length + 1;
  const columnas = medioB.length + 1;

  // Subsecuencia común más larga, de atrás hacia adelante para poder recorrerla hacia adelante.
  const largo = new Uint16Array(filas * columnas);
  for (let i = medioA.length - 1; i >= 0; i--) {
    for (let j = medioB.length - 1; j >= 0; j--) {
      largo[i * columnas + j] = medioA[i] === medioB[j]
        ? largo[(i + 1) * columnas + j + 1] + 1
        : Math.max(largo[(i + 1) * columnas + j], largo[i * columnas + j + 1]);
    }
  }

  const resultado = [];
  if (inicio > 0) agregar(resultado, IGUAL, a.slice(0, inicio).join(""));

  let i = 0;
  let j = 0;
  while (i < medioA.length && j < medioB.length) {
    if (medioA[i] === medioB[j]) {
      agregar(resultado, IGUAL, medioA[i]);
      i++;
      j++;
    } else if (largo[(i + 1) * columnas + j] >= largo[i * columnas + j + 1]) {
      agregar(resultado, QUITADO, medioA[i]);
      i++;
    } else {
      agregar(resultado, AGREGADO, medioB[j]);
      j++;
    }
  }
  while (i < medioA.length) agregar(resultado, QUITADO, medioA[i++]);
  while (j < medioB.length) agregar(resultado, AGREGADO, medioB[j++]);

  if (finA < a.length) agregar(resultado, IGUAL, a.slice(finA).join(""));
  return resultado;
};

export const hayCambios = (original, corregido) =>
  (original || "").replace(/\s+/g, " ").trim() !== (corregido || "").replace(/\s+/g, " ").trim();
